import React from "react";

import { Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()({
  container: {
    padding: 20,
  },
  content: {
    backgroundColor: "white",
    padding: 20,
  },
});

const SupportPage: React.FC = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.content}>
        <Typography>
          Reach us out for any questions or concerns, send us an email thru
          development@gmail.com
        </Typography>
      </Box>
    </Box>
  );
};

export default SupportPage;
